'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
'use strict';

exports.escape = function (input) {
	return input.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

exports.unescape = function (input) {
	return input.replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&#39;/g, '\'').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
};

exports.escapeTag = function (input) {
	var output = input[0];
	for (var i = 1; i < arguments.length; i++) {
		output = output + exports.escape(arguments[i]) + input[i];
	}
	return output;
};

exports.unescapeTag = function (input) {
	var output = input[0];
	for (var i = 1; i < arguments.length; i++) {
		output = output + exports.unescape(arguments[i]) + input[i];
	}
	return output;
};
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

/**
 * Create an element.
 *
 * @param {boolean} safeContent If content is safe to fully unescape
 * @param {String} name The element type name, plus optional classes
 * @param {Object} attributes The element's attributes
 * @param {...any} content The element's content
 */
function createElement(safeContent, name, attributes) {
    if (typeof name != 'string') {
        throw new TypeError('The name argument must be a string');
    }

    var defaultNamespace = document.documentElement.namespaceURI;

    // Handle class names shortcut

    var _name$split = name.split('.'),
        _name$split2 = _toArray(_name$split),
        qName = _name$split2[0],
        classes = _name$split2.slice(1);

    var _getNamespaceParts = getNamespaceParts(qName),
        _getNamespaceParts$na = _getNamespaceParts.namespace,
        namespace = _getNamespaceParts$na === undefined ? defaultNamespace : _getNamespaceParts$na,
        localName = _getNamespaceParts.localName;

    var ele = document.createElementNS(namespace, localName);

    if (classes.length) {
        var _ele$classList;

        (_ele$classList = ele.classList).add.apply(_ele$classList, _toConsumableArray(classes));
    }

    if (attributes != null) {
        if ((typeof attributes === 'undefined' ? 'undefined' : _typeof(attributes)) != 'object') {
            throw new TypeError('The attributes argument must be an object');
        }

        if (attributes instanceof Node) {
            throw new TypeError('The attributes argument cannot be a Node. Did you forget to pass attributes?');
        }

        Object.entries(attributes).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                qName = _ref2[0],
                value = _ref2[1];

            if (value !== null && value !== false) {
                if (value === true) {
                    value = ''; // Treat as boolean attribute
                }

                var _getNamespaceParts2 = getNamespaceParts(qName),
                    _namespace = _getNamespaceParts2.namespace,
                    _localName = _getNamespaceParts2.localName;

                if (_localName.startsWith('on') && typeof value == 'function') {
                    ele.addEventListener(_localName.slice(2), value);
                    return;
                }

                // setAttributeNS() with the HTML namespace doesn't set IDL attributes
                if (_namespace) {
                    ele.setAttributeNS(_namespace, _localName, value);
                } else {
                    ele.setAttribute(_localName, value);
                }
            }
        });
    }

    for (var _len = arguments.length, content = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        content[_key - 3] = arguments[_key];
    }

    content.filter(function (value) {
        return value !== null;
    }).reduce(function (prev, curr) {
        return prev.concat(curr);
    }, []) // flatten
    .forEach(function (value) {
        return ele.appendChild(toNode(value));
    });
    ele.normalize();

    function toNode(value) {
        switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
            case 'boolean':
            case 'number':
                return document.createTextNode(value.toString());
            case 'string':
                value = handleEscapedChars(value);
                return document.createTextNode(value.toString());

            case 'undefined':
                return document.createTextNode('undefined');

            default:
                if (value instanceof Node) {
                    return value;
                }
        }

        throw new TypeError('Argument of type \'' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '\' cannot be used as content.');
    }

    function handleEscapedChars(v) {
        var regExpInEscapedChar = /&#.*;/;
        if (safeContent && regExpInEscapedChar.test(v)) {
            var tmpEle = document.createElement('span');
            tmpEle.innerHTML = v;
            return tmpEle.textContent;
        } else {
            return index.unescape(v);
        }
    }

    function getNamespace(prefix) {
        switch (prefix) {
            case 'html':
                return 'http://www.w3.org/1999/xhtml';
            case 'svg':
                return 'http://www.w3.org/2000/svg';
            case 'xlink':
                return 'http://www.w3.org/1999/xlink';
        }
    }

    function getNamespaceParts(qName) {
        if (qName.indexOf(':') !== -1) {
            var _qName$split = qName.split(':'),
                _qName$split2 = _slicedToArray(_qName$split, 2),
                prefix = _qName$split2[0],
                _localName2 = _qName$split2[1];

            var _namespace2 = getNamespace(prefix);
            if (!_namespace2) {
                throw Error('No namespace found for prefix "' + prefix + '"');
            }
            return { namespace: _namespace2, localName: _localName2 };
        }

        return { localName: qName };
    }
    return ele;
}

// only use createElementFromSafeContent when content is from a secure source
var createElementFromSafeContent = createElement.bind(null, true);
var createElement$1 = createElement.bind(null, false);

exports.createElementFromSafeContent = createElementFromSafeContent;
exports['default'] = createElement$1;
//# sourceMappingURL=index.js.map
